export const REPORTS_INFO = 'REPORTS_INFO';
export const ADD_TO_EXPORT = 'ADD_TO_EXPORT';
export const EXPORT_ALL = 'EXPORT_ALL';
export const CLEAR_EXPORT = 'CLEAR_EXPORT';
export const FILTER_LOADER = 'FILTER_LOADER';
export const REPORT_LOADER = 'REPORT_LOADER';
